import clsx from 'clsx';
import { memo } from 'react';

import type { SideNavDataAttributes } from '../types';

import { Icon } from '../../../../Icon/Icon';

interface SideNavPinButtonProps {
  isPinned: boolean;
  label: string;
  onToggle: () => void;
  dataAttributes?: SideNavDataAttributes;
}

export const SideNavPinButton = memo(function SideNavPinButton({
  dataAttributes,
  isPinned,
  label,
  onToggle,
}: SideNavPinButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={isPinned}
      className={clsx(
        'eds-side-nav--pin',
        isPinned && 'eds-side-nav--pin--pinned',
      )}
      title={label}
      {...dataAttributes}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <Icon filled={isPinned} icon="pin" size="s" />
    </button>
  );
});
